<template>
  <div class="vw100 bg-F2F2F2 pt60 pb57 minh380 column a-center">
    <div class="w-per62_5 column a-center">
      <div class="ft36 font-Regular c-00903B">
        {{ $t('四大产品') }}
      </div>
      <div class="w-per100 row a-center j-sb mt48">
        <div class="flex1" :class="index==0?'':'ml14'" v-for="(item,index) in index_product" :key="index" @click.stop="toPath(item)">
          <img
          loading="lazy"
          class="w-per100"
          referrerpolicy="no-referrer"
          :src="getImageUrl(item.image)"
        />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default{
  data(){
    return {
      
    };
  },
  computed: {
    ...mapGetters({
      index_product:'indexProduct',
    })
  },
  methods:{
    // 跳转
    toPath(item) {
      let u = item.url;
      let str = u.slice(u.indexOf('?')+1);
      let a = str.split('&');
      if(u.includes('/pages/index/index')){
        let p = {
          category_one:a[0]?a[0].slice(a[0].indexOf('=') + 1):0,
          category_two:a[1]?a[1].slice(a[1].indexOf('=') + 1):0,
        }
        let category_one = p.category_one?Number(p.category_one):0;
				let category_two = p.category_two?Number(p.category_two):0;
        this.$router.push({
          path:'/Search',
          query:{
            category_one:category_one,
            category_two:category_two,
          }
        })
      }else if(u.includes('/pagesIndex/goodsDetail/goodsDetail')){
        let id = a[0]?a[0].slice(a[0].indexOf('=') + 1):0;
        this.$router.push({
          path: "/Goods",
          query:{
            id:id,
          }
        })
      }else{
        if(u){
          window.location.href = item.url;
        }
      }
    },
  },
}
</script>

<style scoped lang="scss">

</style>